import * as classnames from 'classnames'
import get from 'lodash-es/get'
import * as React from 'react'

import { publicSearchApi } from '@envato/foundation-types'

import { IItemCard } from '../interface'

import TracksData from './tracksData'

import * as styles from './lockupAudioTrackInfo.module.css'

const LockupAudioTrackInfo = (props: IItemCard) => {
  const attributes = get(props, 'item.attributes', [])
  const classification = get(props, 'item.classification', '')

  const bpm = get(
    attributes.filter(({ name }: publicSearchApi.IAttribute) => name === 'bpm'),
    '[0].value'
  )

  return (
    <span
      className={classnames(styles.root, {
        [styles.grid]: props.viewType === 'grid'
      })}
    >
      <TracksData attributes={attributes} classification={classification} />
      <span className={bpm ? '' : styles.emptyAttribute}>
        BPM <span className={styles.bold}>{bpm ? bpm : '--'}</span>
      </span>
    </span>
  )
}

export default LockupAudioTrackInfo
